import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { BgLoader, PageError, TableZero } from "../../ui";
import { useNavigate, useOutletContext } from "react-router-dom";

import { Helmet } from "react-helmet";


export default function Assignments() {
  let navigate = useNavigate();


  const [state, setState] = useState({});
  const [loader, showLoader] = useState({});

  const [pstate, setTitle] = useOutletContext(); // <-- access context value

  const fetchData = () => {
    instance
      .get("/cust_tasks")
      .then(function (response) {

        setState({ ...state, ...response.data });

      })
      .catch(function (error) { })
      .then(function () { });

  }








  useEffect(() => {
    setTitle('Assignments')
    fetchData()
  }, []);

  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }

  if (pstate.company.task_list == 0) {
    return (
      <PageError msg='Access denied!' />
    )
  }


  return (
    <div>
      <Helmet>
        <title>Assignments</title>
        {pstate.company && pstate.company.logo  &&  <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>
      {state.items && state.items.length > 0 ? (
        <>

          <div className="pt-2">


            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Assignment</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>

              {state.items.map((adata, index) => (
                <tr key={index}>
                  <td>
                    {adata.date}
                  </td>
                  <td>
                    {adata.title}
                  </td>
                  <td>
                    {adata.status}
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
            
          </div>
        </>
      ) : state.items && state.items.length == 0 ? <TableZero title="Assignments"/> : (
        <BgLoader />
      )}
    </div>
  );
}
